
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitofivejyotilingacabd() {



    const cardData =
    {
        keyword: ' Mumbai to 5 Jyotirlinga Cab ',
        heading: 'Deva Cabs: Mumbai to 5 Jyotirlinga Cab ',
        headingDescription: 'Deva Cabs offers specially curated cab services for the Mumbai to 5 Jyotirlinga Yatra, ideal for spiritual tours, family pilgrimages, and devotional journeys. Our well-planned itinerary covers the key Jyotirlinga temples in Maharashtra—Trimbakeshwar, Bhimashankar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Travel in comfort with our fleet of Sedans, SUVs, and Innova Crysta, all driven by experienced chauffeurs familiar with the temple routes and timings. With fixed fare packages, 24/7 support, and customizable schedules, Deva Cabs ensures a sacred and seamless Jyotirlinga Darshan experience from Mumbai.',

        top: 'Top Places to Visit in Maharashtra 5 Jyotirlinga with Deva Cabs',

"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga",
    "location": "Trimbak, Nashik District, Maharashtra",
    "description": "Trimbakeshwar Temple is one of the most revered Jyotirlingas in India, located at the source of the sacred Godavari River. The temple features a unique linga with three faces representing Brahma, Vishnu, and Mahesh. Surrounded by the Brahmagiri Hills, it is known for its spiritual energy, Kushavarta kund, and Vedic rituals like Narayan Nagbali and Kalsarpa Shanti."
  },
  {
    "title": "Grishneshwar Jyotirlinga",
    "location": "Ellora, Aurangabad District, Maharashtra",
    "description": "Located near the UNESCO World Heritage Site of Ellora Caves, Grishneshwar is the last Jyotirlinga on the traditional list of 12. The temple is built in Hemadpanthi style and features intricate carvings and a red sandstone shikhara. It is believed that a devoted woman named Ghushma revived her son here through devotion to Lord Shiva."
  },
  {
    "title": "Bhimashankar Jyotirlinga",
    "location": "Khed Taluka, Pune District, Maharashtra",
    "description": "Bhimashankar Jyotirlinga is nestled in the dense forests of the Sahyadri Hills and is both a religious and ecological hotspot. The temple marks the spot where Lord Shiva destroyed the demon Tripurasura. Apart from its spiritual aura, the area is also known for the Bhimashankar Wildlife Sanctuary and rich biodiversity."
  },
  {
    "title": "Aundha Nagnath Jyotirlinga",
    "location": "Aundha, Hingoli District, Maharashtra",
    "description": "Aundha Nagnath is considered the first Jyotirlinga and is closely associated with the Pandavas, who are believed to have built the temple during their exile. The temple showcases ancient architecture with intricate carvings, large courtyards, and deep spiritual significance, especially among devotees of Shiva and Nath sects."
  },
  {
    "title": "Parli Vaijnath Jyotirlinga",
    "location": "Parli, Beed District, Maharashtra",
    "description": "Parli Vaijnath Jyotirlinga is believed to grant health and healing to its devotees. The temple is constructed in stone and wood, and features influences from the Hemadpanthi style. Mythologically, it is linked to Ravana who worshipped Shiva here. The temple is especially crowded during Shravan and Mahashivratri."
  }
],



"services": [
  {
    "name": "Mumbai to 5 Jyotirlinga Cab",
    "description": "Embark on a spiritually fulfilling journey to the 5 sacred Jyotirlingas of Maharashtra — Trimbakeshwar, Bhimashankar, Aundha Nagnath, Parli Vaijnath, and Grishneshwar — with Deva Cabs’ Mumbai to 5 Jyotirlinga cab service. Our expert drivers and well-maintained vehicles ensure a seamless multi-day pilgrimage across long distances. Enjoy door-to-door service, flexible trip customization, and spiritual comfort throughout your holy yatra."
  },
  {
    "name": "Jyotirlinga Darshan taxi from Mumbai",
    "description": "Deva Cabs offers reliable taxi services from Mumbai for Jyotirlinga Darshan covering major spiritual destinations in Maharashtra. Whether you are planning a one-way trip or a round tour of all five Jyotirlingas, our service includes planned itineraries, meal stops, and hotel coordination support. Ideal for religious groups, elderly devotees, or families seeking a stress-free pilgrimage experience."
  },
  {
    "name": "Book 5 Jyotirlinga cab online Mumbai",
    "description": "Easily book your Jyotirlinga Darshan cab online from Mumbai with Deva Cabs’ user-friendly platform. Our booking system offers instant confirmation, transparent pricing, and options for sedans, SUVs, or tempo travellers. Whether for an individual spiritual seeker or a group of devotees, get tailored cab packages designed to cover all five temples efficiently and comfortably."
  },
  {
    "name": "AC cab for Jyotirlinga from Mumbai",
    "description": "Travel in comfort with our fully air-conditioned cabs for your 5 Jyotirlinga journey from Mumbai. Our vehicles come with push-back seats, clean interiors, and ample luggage space — perfect for long-distance travel. Beat the heat and dust of rural routes while enjoying a calm and composed trip to each revered Jyotirlinga temple."
  },
  {
    "name": "Luxury Jyotirlinga tour cab Mumbai",
    "description": "Experience premium comfort on your Jyotirlinga tour with Deva Cabs’ luxury cab rentals. Our fleet includes Innova Crysta, Toyota Fortuner, and other upscale vehicles driven by uniformed, experienced chauffeurs. Ideal for travelers seeking elevated service levels during their pilgrimage, complete with refreshments, music, and plush seating for long hours."
  },
  {
    "name": "Pilgrimage cab Mumbai to 5 Jyotirlinga",
    "description": "Our dedicated pilgrimage cab service from Mumbai to the 5 Jyotirlingas is curated for devotional travelers. From assisting with temple schedules and darshan timings to planning safe overnight halts, our service ensures your spiritual focus remains uninterrupted. Clean vehicles, trained drivers, and flexible pickup options make this a trusted travel choice."
  },
  {
    "name": "Chauffeur-driven Jyotirlinga taxi Mumbai",
    "description": "Deva Cabs provides chauffeur-driven taxis for a comfortable and guided Jyotirlinga pilgrimage from Mumbai. Our drivers are not only skilled behind the wheel but also familiar with temple locations, lodging stops, and ideal travel hours. They ensure smooth travel while assisting with luggage, route changes, and en route temple etiquette."
  },
  {
    "name": "Affordable Mumbai to Jyotirlinga cab",
    "description": "Travel economically without compromising comfort or reliability. Our affordable cab service to the 5 Jyotirlingas from Mumbai includes fuel, tolls, and driver charges in clear, upfront pricing. Whether you're traveling solo or in a group, we offer cost-effective packages with flexible scheduling and support throughout your religious trip."
  },
  {
    "name": "Family cab for Jyotirlinga trip Mumbai",
    "description": "Take your family on a sacred journey to Maharashtra’s 5 Jyotirlingas with Deva Cabs’ family cab services. Our large vehicles offer space, safety, and entertainment options for kids and elders. The entire itinerary can be paced to your family’s comfort with rest stops, food breaks, and customized temple visit durations."
  },
  {
    "name": "Mumbai to Trimbakeshwar Bhimashankar Aundha Nagnath Parli Vaijnath Grishneshwar Cab",
    "description": "Visit the 5 Jyotirlingas — Trimbakeshwar, Bhimashankar, Aundha Nagnath, Parli Vaijnath, and Grishneshwar — with our specialized Mumbai pilgrimage cab package. This all-in-one service covers every major Jyotirlinga in Maharashtra with planned routing, comfortable long-distance vehicles, spiritual ambiance, and experienced drivers who understand the significance of every temple."
  }
],
"tableData": [
  ["Mumbai to 5 Jyotirlinga Cab", "-Jyotirlinga Darshan taxi from Mumbai"],
  ["Book 5 Jyotirlinga cab online Mumbai", "-AC cab for Jyotirlinga from Mumbai"],
  ["Luxury Jyotirlinga tour cab Mumbai", "-Pilgrimage cab Mumbai to 5 Jyotirlinga"],
  ["Chauffeur-driven Jyotirlinga taxi Mumbai", "-Affordable Mumbai to Jyotirlinga cab"],
  ["Family cab for Jyotirlinga trip Mumbai", "-Mumbai to Trimbakeshwar Bhimashankar Aundha Nagnath Parli Vaijnath Grishneshwar Cab"]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to 5 Jyotirlinga Pilgrimage Cab Service",
    "WhyChoosedescription": "Embark on a spiritual journey covering five sacred Jyotirlinga temples from Mumbai with our reliable cab service. Whether you’re planning a religious tour for devotion or cultural exploration, our service ensures timely pickups, efficient route management, and a comfortable travel experience across multiple destinations, making your pilgrimage smooth and fulfilling."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Long-Distance Pilgrimage",
    "WhyChoosedescription": "Our well-maintained, air-conditioned vehicles provide the comfort needed for long journeys covering the Jyotirlinga temples. With ample seating, generous legroom, and space for luggage, our cabs are perfect for families, groups, or solo travelers embarking on this spiritually significant route spanning several hundred kilometers."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Jyotirlinga Routes",
    "WhyChoosedescription": "Our drivers are skilled and knowledgeable about the best routes connecting the five Jyotirlinga temples, including Somnath, Bhimashankar, Trimbakeshwar, Grishneshwar, and Mahakaleshwar. They ensure a safe, smooth ride, taking care of all driving challenges, road conditions, and traffic patterns so you can focus on your spiritual journey."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We offer clear pricing with no hidden fees, covering tolls, fuel, driver allowances, and taxes. Our affordable packages make this extensive pilgrimage accessible, allowing you to plan your travel budget confidently without worrying about unexpected costs."
  },
  {
    "WhyChooseheading": "24/7 Availability to Fit Your Pilgrimage Schedule",
    "WhyChoosedescription": "Understanding the unique timings and requirements of religious journeys, our cabs are available round the clock. Whether you want to start early morning or travel late at night to catch temple darshan, we accommodate your schedule, providing flexibility and convenience throughout the pilgrimage."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Booking your Mumbai to 5 Jyotirlinga cab is hassle-free through our user-friendly website or customer support. Receive instant confirmation, fare details, and driver information, making your entire travel planning process smooth and transparent."
  },
  {
    "WhyChooseheading": "Safety and Well-Maintained Vehicles",
    "WhyChoosedescription": "Your safety is paramount. All vehicles undergo rigorous maintenance and sanitization before each trip. Equipped with seat belts, GPS, and emergency kits, our fleet and trained drivers ensure a secure and comfortable pilgrimage experience."
  },
  {
    "WhyChooseheading": "Customizable Itineraries to Suit Your Spiritual Needs",
    "WhyChoosedescription": "Whether you want a quick tour covering all five Jyotirlingas or a relaxed multi-day pilgrimage with ample time at each temple, we tailor the travel plan to your preferences. Our flexible packages accommodate solo travelers, families, and groups, ensuring a personalized spiritual journey."
  }
]









    }








const faqData = [
  {
    question: "Does Deva Cabs offer Mumbai to 5 Jyotirlinga cab service?",
    answer: "Yes, Deva Cabs provides dedicated cab services for the 5 Jyotirlinga Yatra from Mumbai, covering key pilgrimage sites across Maharashtra."
  },
  {
    question: "Which Jyotirlingas are covered in the 5 Jyotirlinga Yatra from Mumbai?",
    answer: "The 5 Jyotirlingas typically include Trimbakeshwar (Nashik), Bhimashankar, Grishneshwar (Aurangabad), Aundha Nagnath, and Parli Vaijnath."
  },
  {
    question: "How many days does the 5 Jyotirlinga trip take by cab?",
    answer: "The full yatra generally takes 3 to 5 days depending on your schedule and time spent at each temple."
  },
  {
    question: "Can I customize the itinerary and duration of the 5 Jyotirlinga Yatra?",
    answer: "Yes, Deva Cabs offers fully customizable packages to suit your travel preferences and time availability."
  },
  {
    question: "What types of vehicles are available for this pilgrimage?",
    answer: "We offer clean and spacious vehicles including sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers for group travel."
  },
  {
    question: "Are the drivers familiar with the Jyotirlinga routes and temple timings?",
    answer: "Yes, our experienced drivers are well-versed with all temple routes, ideal for a spiritual and smooth journey."
  },
  {
    question: "Are tolls, driver allowance, and parking included in the cab fare?",
    answer: "These charges are usually additional and will be clearly communicated at the time of booking."
  },
  {
    question: "Is this trip suitable for elderly or senior citizens?",
    answer: "Yes, our cab service is comfortable, safe, and ideal for senior citizens and family groups."
  },
  {
    question: "Is it safe to travel long-distance with Deva Cabs?",
    answer: "Absolutely. All our drivers are background-verified and trained for long-distance and spiritual tour travel."
  },
  {
    question: "Why book your 5 Jyotirlinga Yatra with Deva Cabs?",
    answer: "Deva Cabs provides reliable vehicles, professional drivers, flexible itineraries, and complete support for a peaceful pilgrimage experience."
  }
];

const testimonialData = [
  {
    id: 47,
    name: 'Mr. Suresh Shinde',
    role: 'Pilgrim',
    review: 'Deva Cabs made our 5 Jyotirlinga Yatra from Mumbai absolutely smooth. The driver was courteous and knew all the routes. It was a divine journey.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 48,
    name: 'Ms. Meena Joshi',
    role: 'Devotional Traveler',
    review: 'We visited all 5 Jyotirlingas with Deva Cabs. The vehicle was spacious and comfortable. Great experience for spiritual travelers.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];










































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to 5 Jyotirlinga Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-5-jyotirlinga-cab.jpg", // Replace with actual image URL
  "description": "Book Mumbai to 5 Jyotirlinga cab tour with Deva Cabs for a spiritual and comfortable journey. Visit Somnath, Mallikarjuna, Mahakaleshwar, Omkareshwar, and Kedarnath with reliable cabs, professional drivers, and affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12999",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-5-jyotirlinga-cab"
  }
};








    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to 5 Jyotirlinga Cab Tour | Spiritual Taxi Service</title>
  <meta 
    name="description" 
    content="Book Mumbai to 5 Jyotirlinga cab tour with Deva Cabs. Comfortable and reliable taxi service to Somnath, Mallikarjuna, Mahakaleshwar, Omkareshwar, and Kedarnath. Affordable fares and professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to 5 Jyotirlinga Cab, Jyotirlinga Cab Tour Mumbai, Mumbai to Somnath Cab, Mumbai to Mallikarjuna Cab, Mumbai to Mahakaleshwar Cab, Mumbai to Omkareshwar Cab, Mumbai to Kedarnath Cab, Deva Cabs Jyotirlinga Tour, Spiritual Cab Service Mumbai, Affordable Taxi Mumbai Jyotirlinga" 
  />
  <link rel="canonical" href="https://devacab.com/mumbai-to-5-jyotirlinga-cab" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/32.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitofivejyotilingacabd;